/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Total/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaHorizDivider from 'DesignSystem/TysiaHorizDivider/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Total({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/PaymentsTreatmentPlan/Content/TreatmentPayments/Content/Content/SetupPayment/Breakdown/PayerInfo/Total"
  
}) {
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
let payerDataTotalValueData = fromData.useDataFormat({ viewPath,
context: 'payer',
path: 'data.total',
format: fromFormat.numberMoney,
})
  return (<React.Fragment
>
<TysiaHorizDivider
  viewPath={`${viewPath}/TysiaHorizDivider`}
 marginTop={0}
 marginBottom={12}
 backgroundColor={dtColorsNeutral200}
/>
<div
  data-testid="Total.Horizontal"
  data-view-path={viewPath}
 style={{'--pb-1-5PPze': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral600}
 text="Total"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 data="payer.data.total"
 format="/Data/format.js numberMoney"
 text={payerDataTotalValueData}
/>
</div>
{children}
</React.Fragment>)
}